
import { defineComponent, ref } from 'vue'
import ModalBase from '@/views/modal/ModalBase.vue'
import LoadingButton from '@/views/components/LoadingButton.vue'
import { callApiWrapper } from '@/views/callApiWrapper'
import ResponseResultAlert from '@/views/components/ResponseResultAlert.vue'
import { userRepository } from '@/repositories/admin/userRepository'

export default defineComponent({
  components: {
    ResponseResultAlert,
    LoadingButton,
    ModalBase
  },
  props: {
    userKey: {
      type: String,
      required: true
    },
    loginId: {
      type: String,
      required: true
    }
  },
  emits: {
    dismiss: () => true,
    send: () => true
  },
  setup (props, { emit }) {
    const requestError = ref<string | null>(null)
    const isWaiting = ref(false)
    const isResponseSucceed = ref(false)

    const dismiss = () => {
      emit('dismiss')
    }

    const sendWelcomeMail = async () => {
      isWaiting.value = true
      await callApiWrapper(requestError, async () => {
        await userRepository.sendWelcomeUser(props.userKey)
        isResponseSucceed.value = true
        emit('send')
      })
      isWaiting.value = false
    }

    return {
      requestError,
      isWaiting,
      isResponseSucceed,
      dismiss,
      sendWelcomeMail
    }
  }
})
